<template>
  <div>
    <v-row class="mx-2">
      <v-col cols="12" md="6" class="flex-items">
        <v-tabs v-model="activeTab" color="#519043" align-tabs="left">
          <v-tab
            v-for="tab in tabList"
            :key="tab.id"
            @change="changeTab(tab)"
            >{{ tab.name }}</v-tab
          >
        </v-tabs>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="12" md="6" class="d-flex justify-space-between">
        <v-text-field
          v-model="search"
          outlined
          prepend-inner-icon="search"
          label="Search"
          single-line
          hide-details
          class="rounded-lg"
          color="#239FAB"
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-card class="ma-5 dt-container" elevation="0" outlined>
      <v-data-table
        :headers="tab != 2 ? headers : headers1"
        :items="data"
        :items-per-page="10"
        :search="search"
        :options.sync="options"
        :loading="loading"
        @pagination="pagination"
        hide-default-footer
      >
        <!-- <template v-slot:[`item.period`]="{ item }">
          {{ getPeriodDescription(item.period) }}
        </template> -->
        <!-- <template v-slot:[`item.assesed_by_status`]="{ item }">
          <v-chip
            v-if="!item.isWorkback"
            x-small
            class="pa-1"
            :class="
              getStatus('assess', item) == 'For Submission' ||
              getStatus('assess', item) == 'For Approval'
                ? ''
                : 'white--text'
            "
            :color="
              getStatus('assess', item) == 'For Submission' ||
              getStatus('assess', item) == 'For Approval'
                ? ''
                : getStatus('assess', item) == 'Approved'
                ? 'green'
                : 'red'
            "
          >
            {{ getStatus("assess", item) }}
          </v-chip>
        </template>
        <template v-slot:[`item.final_rating_by_status`]="{ item }">
          <v-chip x-small class="pa-1" v-if="!item.isWorkback">
            {{ getStatus("final_rating", item) }}
          </v-chip>
        </template> -->

        <template v-slot:[`item.action`]="{ item }">
          <v-btn
            class="my-1"
            block
            x-small
            @click="view(item)"
            outlined
            color="warning"
            >View</v-btn
          >

          <!-- <v-btn
            class="my-1"
            block
            x-small
            @click="deleteItem(item)"
            outlined
            color="red"
            >Delete</v-btn
          > -->
        </template>
      </v-data-table>
    </v-card>
    <v-row class="mb-2 mx-5" align="center">
      <v-col cols="auto" class="mr-auto text-truncate flex-items" no-gutters>
        <span class="px-2">Show</span>
        <span>
          <v-select
            dense
            outlined
            color="#519043"
            hide-details
            :value="options.itemsPerPage"
            style="max-width: 90px"
            class="rounded-lg"
            @change="options.itemsPerPage = parseInt($event, 10)"
            :items="perPageChoices"
          >
          </v-select>
        </span>
        <span class="px-2"> Entries </span>
      </v-col>

      <v-col cols="auto" class="mr-auto text-truncate" no-gutters>
        Showing {{ paginationData.pageStart + 1 }} to
        {{ paginationData.pageStop }} of
        {{ paginationData.itemsLength }} entries
      </v-col>
      <v-col cols="auto">
        <v-pagination
          v-model="options.page"
          class="rounded-lg"
          :total-visible="7"
          :color="$vuetify.theme.themes.light.submitBtns"
          :length="paginationData.pageCount"
        >
        </v-pagination>
      </v-col>
    </v-row>

    <!-- delete dialog -->
    <v-dialog v-model="confirmDialog" persistent max-width="390">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">WARNING!</div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to delete this information?<br /><br />
              Please note that
              <b>this action is irreversible.</b>
            </p>
          </div>
        </div>

        <!-- <v-card-title class="text-h5">
          Are you sure you want to proceed?
        </v-card-title> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="cancelDelete()"> Close </v-btn>
          <v-btn color="green" class="white--text" @click="confirmDelete()">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <PlanningOPCRTargetApprovalDialog :data="opcrData" :tbl_tab="tab" />
    <!-- <OPCRTargetDialog :data="opcrData" :action="action" />
    <OPCRSummaryDialog :data="opcrSumData" />
    <RateOPCRTargetDialog :data="rateOpcr" />
    <ViewOPCRDialog :data="opcr" /> -->

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
      :timeout="5000"
    ></fade-away-message-component>
  </div>
</template>
<script>
import PlanningOPCRTargetApprovalDialog from "../../Dialogs/Forms/OPCR/PlanningOPCRTargetApprovalDialog.vue";

export default {
  components: {
    PlanningOPCRTargetApprovalDialog,
  },
  data: () => ({
    confirmDialog: false,
    itemToDelete: null,
    search: "",
    fullname: null,
    applicantData: null,
    itemData: null,
    taggingData: null,
    opcrData: null,
    supportData: null,
    rateOpcr: null,
    headers: [
      {
        text: "Year",
        value: "year",
        align: "start",
        valign: "center",
        sortable: false,
      },

      {
        text: "Office",
        value: "office_name",
        align: "start",
        valign: "center",
        sortable: false,
      },

      {
        text: "Action",
        value: "action",
        align: "center",
        width: 100,
        valign: "center",
        sortable: false,
      },
    ],
    headers1: [
      {
        text: "Year",
        value: "year",
        align: "start",
        valign: "center",
        sortable: false,
      },

      {
        text: "Office",
        value: "office_name",
        align: "start",
        valign: "center",
        sortable: false,
      },
      {
        text: "Approved By",
        value: "planning_officer_name",
        align: "start",
        valign: "center",
        sortable: false,
      },

      {
        text: "Action",
        value: "action",
        align: "center",
        width: 100,
        valign: "center",
        sortable: false,
      },
    ],

    data: [],

    perPageChoices: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "20", value: 20 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "250", value: 250 },
      { text: "500", value: 500 },
    ],
    activeTab: { id: 1, name: "For Approval" },
    tab: 1,
    tabList: [
      { id: 1, name: "For Approval" },
      { id: 2, name: "Approved" },
      { id: 3, name: "Pending" },
    ],
    mporData: null,
    opcr: null,
    opcrSumData: null,
    loading: false,
    options: {},
    action: null,
    paginationData: {},
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Deleted!",
      message: "",
      top: 10,
    },
    yearList: [],
  }),

  mounted() {
    this.eventHub.$on("closePlanningOPCRTargetApprovalDialog", () => {
      this.initialize();
    });
  },

  beforeDestroy() {
    this.eventHub.$off("closePlanningOPCRTargetApprovalDialog");
  },
  watch: {
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    filterYear: {
      handler(newData, oldData) {
        if (oldData != newData) {
          this.initialize();
        }
      },
      deep: true,
    },
  },
  computed: {
    filterYear() {
      return this.$store.getters.getFilterSelected;
    },
  },
  methods: {
    getPeriodDescription(id) {
      for (let i = 0; i < this.periodList.length; i++) {
        if (this.periodList[i].id == id) {
          return this.periodList[i].description;
        }
      }
    },
    pagination(data) {
      this.paginationData = data;
    },

    initialize() {
      this.axiosCall(
        "/opcr-target/getPlanningApproval/" + this.tab,
        "GET"
      ).then((res) => {
        if (res) {
          console.log("APPRTOVA", res.data);
          this.data = res.data;
          this.loading = false;
        }
      });
    },

    getStatus(type, item) {
      let toReturn = "";
      if (type == "assess") {
        if (item.isSubmitted == 0) {
          toReturn = "For Submission";
        } else {
          if (item.assesed_by_status == 1) {
            toReturn = "For Approval";
          } else if (item.assesed_by_status == 2) {
            toReturn = "Approved";
          } else if (item.assesed_by_status == 3) {
            toReturn = "Pending";
          }
        }
      } else if (type == "final_rating") {
        if (item.isSubmitted == 0) {
          toReturn = "For Submission";
        } else {
          if (item.final_rating_by_status == null) {
            toReturn = "For Submission";
          } else if (item.final_rating_by_status == 1) {
            toReturn = "For Approval";
          } else if (item.final_rating_by_status == 2) {
            toReturn = "Approved";
          } else if (item.final_rating_by_status == 3) {
            toReturn = "Pending";
          }
        }
      }
      return toReturn;
    },

    changeTab(tab) {
      this.activeTab = tab;

      // if (tab.id == 1) {

      this.tab = tab.id;
      this.initialize();
      // } else if (tab.id == 2) {
      //   this.getVerifiedUsers();
      //   this.tab = tab.id;
      // }
    },

    view(item) {
      console.log(item);
      this.opcrData = item;
      // this.action = "Update";
    },

    deleteItem(item) {
      this.itemToDelete = item;
      this.confirmDialog = true;
    },
    confirmDelete() {
      this.axiosCall("/ipcr/" + this.itemToDelete.id, "DELETE").then((res) => {
        if (res.data.status == 200) {
          this.confirmDialog = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.initialize();
        } else {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
        }
      });
    },
    cancelDelete() {
      this.itemToDelete = null;
      this.confirmDialog = false;
    },
  },
};
</script>
